import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleMaintenanceSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle opacity={0.88} cx={28} cy={28} r={28} fill="#56A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.45 35.1l-5.95-5.95a3.77 3.77 0 00-4.33-.7l-5.42-5.42v-2.66a1 1 0 00-.4-.8l-5.4-4.05a1 1 0 00-1.31.1l-2.02 2.02a1 1 0 00-.1 1.3l4.06 5.4a1 1 0 00.8.41h2.65l5.41 5.41a3.78 3.78 0 00.71 4.34l5.95 5.95c.74.74 1.94.74 2.67 0l2.68-2.68a1.9 1.9 0 000-2.68zm-8.6-8.67c1.43 0 2.78.55 3.8 1.57l.98.98a7.3 7.3 0 004.15-8.44.6.6 0 00-1.02-.27l-3.13 3.12-3.44-.57-.58-3.45 3.13-3.13a.61.61 0 00-.29-1.02 7.3 7.3 0 00-6.94 1.92 7.2 7.2 0 00-2.09 5.26l4.17 4.17c.41-.1.84-.14 1.26-.14zm-8.16 1.28l2.88 2.88a5.45 5.45 0 00.25 3.18l-6.27 6.28a3.25 3.25 0 11-4.6-4.6l7.74-7.74zm-6.66 10.04a1.22 1.22 0 101.22-1.22c-.67 0-1.22.54-1.22 1.22z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.95 30.95a.5.5 0 00-.7 0l-.36.36a.5.5 0 000 .7l6.65 6.65 1.06-1.06-6.65-6.65zm-1.9 1.9a.5.5 0 00-.7 0l-.36.36a.5.5 0 000 .7l6.65 6.65 1.06-1.06-6.65-6.65z"
        fill="#8F9DD6"
      />
    </svg>
  );
}

SvgPicCircleMaintenanceSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleMaintenanceSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleMaintenanceSelected svgRef={ref} {...props} />
));
export default ForwardRef;
